import { ApiCallError } from 'app/http/ApiCallError';
import { getApiCallErrorMessage } from 'app/http/getApiCallErrorMessage';

const FALLBACK_MESSAGE = 'Something went wrong.';

const getServerErrorBodyMessage = (error: ApiCallError): string | undefined => {
  if (error.status === undefined || error.status < 500) {
    return undefined;
  }
  const { body } = error;
  if (typeof body === 'object' && body !== null && 'message' in body && typeof body.message === 'string') {
    return body.message.trim() || undefined;
  }
  return undefined;
};

export const getModelChoiceErrorMessage = (error: unknown): string => {
  if (!(error instanceof ApiCallError)) {
    return FALLBACK_MESSAGE;
  }
  return getServerErrorBodyMessage(error) ?? getApiCallErrorMessage(error);
};
